import { Component, inject } from '@angular/core';
import { StorageLocationService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  StorageLocationCreateDto,
  StorageLocationDto,
  StorageLocationExcelDownloadDto,
  StorageLocationUpdateDto,
} from '../proxy/controlling/dtos/storage-location';
import { STORAGELOCATION_CONFIG, STORAGELOCATION_FIELDS } from './storage-location.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-storage-location',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, StorageLocationService, ConfirmationService],
  templateUrl: './storage-location.html',
  styleUrl: './storage-location.scss',
})
export class StorageLocation extends BaseCrudComponent<
  StorageLocationDto,
  StorageLocationCreateDto,
  StorageLocationUpdateDto,
  StorageLocationExcelDownloadDto
> {
  service = inject(StorageLocationService);
  config = STORAGELOCATION_CONFIG;
  fields = STORAGELOCATION_FIELDS;

  protected prepareUpdateDto(data: any, selected: StorageLocationDto): StorageLocationUpdateDto {
    return {
      name: data.name,
      sapCode: data.sapCode,
      sapPlantId: data.sapPlantId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'StorageLocation';
  }
}
